// extracted by mini-css-extract-plugin
export var articleList = "ArticleList-module--articleList--IGipv";
export var articleListItem = "ArticleList-module--articleListItem--1GrV3";
export var articleListDescription = "ArticleList-module--articleListDescription--3yYaQ";
export var articleListTitle = "ArticleList-module--articleListTitle--pXsF9";
export var articleListLogo = "ArticleList-module--articleListLogo--OjuUZ";
export var articleListLink = "ArticleList-module--articleListLink--1tJBP";
export var articleListPublisher = "ArticleList-module--articleListPublisher--k7Rzv";